import { createSelector } from "reselect";
import getRunningProcesses from "../base_getters/get_running_processes";

const getPipelineRunningProcessesById = createSelector([
  getRunningProcesses
], (runningProcesses) => runningProcesses.byId);

export default getPipelineRunningProcessesById;
